import { render, staticRenderFns } from "./SendConvoModal.vue?vue&type=template&id=2b251439&"
import script from "./SendConvoModal.vue?vue&type=script&lang=js&"
export * from "./SendConvoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports